import { ISagaModule } from "redux-dynamic-modules-saga";
import { call, put, select } from "redux-saga/effects";
import { appUrls } from "../../EasyProjectsCommon/AppUrls";
import { OAuthClient } from "../../EasyProjectsCommon/OAuthClient";
import { createReducerWithReinit } from "../AppReinit";
import { createValueReducer, setValueActionCreator } from "../Reducers/ValueReducer";
import { handleApiError } from "../Sagas/effects/handleApiError";
import { UserPermissionsState } from "./types";
import { UserPermissions, UserPermissionsActionTypes } from "./types";

export const setUserPermissions = setValueActionCreator<UserPermissions>(
    UserPermissionsActionTypes.SET_USER_PERMISSIONS
);
export const userPermissionsReducer = createValueReducer<UserPermissions>(
    UserPermissionsActionTypes.SET_USER_PERMISSIONS
);

export const getUserPermissions = (state: UserPermissionsState) => state.userPermissions;

export function* loadUserPermissions() {
    let permissions: UserPermissions = yield select(getUserPermissions);
    if (permissions) {
        return;
    }

    try {
        permissions = yield call(() => {
            return OAuthClient.postJson(appUrls.usermanagement.permissions).then(resp => resp);
        });
        yield put(setUserPermissions(permissions));
    } catch (e) {
        yield call(handleApiError, e);
    }
}

export const getUserPermissionsModule = (): ISagaModule<UserPermissionsState> => ({
    id: "userPermissions",
    reducerMap: {
        userPermissions: createReducerWithReinit(() => userPermissionsReducer),
    },
    sagas: [loadUserPermissions],
});
